import React from 'react';
import { BrowserRouter as Router, Route, Link, Routes } from 'react-router-dom';
import HomePage from './components/HomePage';
import KlachtenregelingPage from './components/KlachtenregelingPage';
import BoekTaxi from './components/BoekTaxi';
import AlgemeneVoorwaarden from './components/algemene-voorwaarden'; // Importeer de AlgemeneVoorwaarden component
import './App.css';

function App() {
    return (
        <Router>
            <div className="App">
                <nav>
                    <ul>
                        <li>
                            <Link to="/">Home</Link>
                        </li>
                        {/*
                        <li>
                            <Link to="/boektaxi">Boek een taxi</Link>
                        </li>
                        */}
                    </ul>
                </nav>

                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/boektaxi" element={<BoekTaxi />} />
                    <Route path="/klachtenregeling" element={<KlachtenregelingPage />} />
                    <Route path="/algemene-voorwaarden" element={<AlgemeneVoorwaarden />} /> {/* Route voor Algemene Voorwaarden */}
                </Routes>

                <div style={{ marginBottom: '80px' }}></div>

                <nav className="bottom-nav">
                    <ul>
                        <li style={{ fontSize: '0.8em' }}>
                            <Link to="/klachtenregeling">Klachtenregeling</Link>
                        </li>
                        <li style={{ fontSize: '0.8em' }}>
                            <Link to="/algemene-voorwaarden">Algemene Voorwaarden</Link>
                        </li>
                    </ul>
                </nav>
            </div>
        </Router>
    );
}

export default App;
